import axios from 'axios';

const getLanguage = () => localStorage.getItem("lang") || localStorage.getItem("i18nextLng") || "ar";

const api = axios.create({
    baseURL: `${process.env.REACT_APP_PROVIDER}`,
    headers: {
        platform: 'agent',
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use((config) => {
    const language = getLanguage();
    config.headers = config.headers || {};
    config.headers["Accept-Language"] = language;
    config.headers.language = language;
    return config;
});

api.interceptors.response.use(
    (response) => {
        // Pass through successful responses
        return response;
    },
    (error) => {

        console.log(`error is ${error}`)
        if (parseInt(error.response?.status) === 401) {

            const status = error.response?.status;
            const message = error.response?.data?.message || error.message;
            const url = error.config?.url || 'Unknown URL';






            // localStorage.removeItem("token")
            // window.location.href = '/';
        }
        // Always reject the promise so calling code can handle other errors
        return Promise.reject(error);
    }
);

export default api;